import React, { useEffect, useState, useRef, useCallback, useContext, useMemo } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Axios from '../../axios-proas';
import { useTranslation } from 'react-i18next';

import { getNotyfObject, getArbreJson, flattenData, bailleursTries, checkValidity, getHierarchieBailleur, renameSousNiveau, renameArrayProperties, addTestPropertyRecursive, searchTreeHierarchie, searchTreeBailleur } from '../../shared/utility';
import { connect } from 'react-redux';
import { EntContainer, EntContent, EntHeader, EntHeaderActions, EntHeaderTitle2, EntHeaderTitle, EntHeaderTitleDiv, EntFormList, EntHeaderWrapper, EIFormContainer2, EntFormItem, OptionDiv, OptionContainer } from './UserForm.styled'
import { useTheme } from 'styled-components';
import { PrimaryBtnOutlineAction, SecondaryBtnOutlineAction, CancelBtnOutlineAction } from '../../styles/Common';
import { SpinnerContainer } from '../../styles/Table.styled';
import { Spinner } from 'react-bootstrap';
import { EntInfosContainer, EIFormCol, EIFormCol2, EIContainer, EIFormColInfo, FormGroup } from '../../components/Entity/InfosLevel/InfosLevel.styled';
import MandatoryMarker from '../../components/UI/MandatoryMarker';
import frLocale from "date-fns/locale/fr";
import * as actions from '../../store/actions/index';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import DropDownRoles from '../../components/Entity/DropDown/DropDownRoles';
import DropDown from '../../components/Entity/DropDown/DropDown';
import DropDownLevel from '../../components/Entity/DropDown/DropDownLevel';
import DropDownPermissions from '../../components/Entity/DropDown/DropDownPermission';

import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import { CTooltip } from '../../components/UI/CTooltip/CTooltip';
import { FormInput, FormLabel, FormSelect, SearchInput } from '../../styles/Common';
import ConfirmationModal from '../../components/UI/ConfirmationModal/ConfirmationModal';
import { IconDiv, EICol } from '../../components/Entity/Infos/Infos.styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo, faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import { AbilityContext } from '../../ability/AbilityContext';
import { createContextualCan } from '@casl/react'

const Can = createContextualCan(AbilityContext.Consumer);

function UserEntity({ userType, contact, connectedUserId, userAdminForUserData, getUsersPage, reverse, sortQuery, filtersQuery, currentPage, pageSize, currentPagecontact, listOfRoles,access_data_assu_key,access_data_key, uidBailleur, show, closeModal, codeBailleur, hierarchicalTemp, niveauTemp, userRoles, entity, isNewUser }) {
    const [contactCopie, setContactCopie] = useState(contact);
    const [accessEnqueteType, setAccessEnqueteType] = useState("full");
    const [accessAttestationType, setAccessAttestationType] = useState("full"); 
    const theme = useTheme()
    const [inputValue, setInputValue] = useState();
    let { uid } = useParams();
    const navigate = useNavigate();
    const notyf = getNotyfObject();
    const { t } = useTranslation();
    const [niveau, setNiveau] = useState([])
    const [hierarchicalForEnquete, setHierarchicalForEnquete] = useState([])
    const [hierarchicalForAttestation, setHierarchicalForAttestation] = useState([])
  
    const [user, setUser] = useState({});
    const [typeUser, setTypeUser] = useState("BAILLEUR");
    const [bailleurs, setBailleurs] = useState([]);
    const [bailleurCode, setBailleurCode] = useState('')
    const [errors, setErrors] = useState(null);
    const [confirmDeleteUser, setConfirmDeleteUser] = useState()
    const [entityData, setEntityData] = useState([]);
    const ability = useContext(AbilityContext);
    const [searchQuery, setSearchQuery] = useState(null)
    const [searchQueryHierarchie, setSearchQueryHierarchie] = useState(null)
    const [havingHierarchieBailleur, setHavingHierarchieBailleur] = useState(false)

    const checkUserFormValidity = (contact, type) => {

        let errors = []
        if (!contact.hasOwnProperty('userName') || !checkValidity(contact?.userName, { required: true })) {
            errors.push(t("masterData:userName", "L'identifiant est vide ou non valide"));
        }
        //if (!contact.hasOwnProperty('family_name') || !checkValidity(contact?.family_name, { required: true })) {
        //    errors.push(t("masterData:error_userType", "Le Prénom est vide ou non valide"));
        //}
        if (!checkValidity(contact?.claims?.filter(claim => claim?.claimType == "urn:younov:displayname")[0]?.claimValue, { required: true })) {
            errors.push(t("masterData:displayname", "Le Nom est vide ou non valide"));
        }
        if (!contact.hasOwnProperty('email') || !checkValidity(contact?.email, { required: true, isEmail: true })) {
            errors.push(t("masterData:email", "Le champ 'Email' est vide ou non valide"));
        }

        if (!contact.hasOwnProperty('roles') || !contact?.roles.length > 0) {
            errors.push(t("masterData:roles", "Veuillez sélectionner un rôle pour l'utilisateur"));
        }
        if (contact.hasOwnProperty('phoneNumber') && contact?.phoneNumber?.length > 0 && !checkValidity(contact?.phoneNumber, { isNumeric: true, minLength: 10, maxLength: 10, isTelPortable: true })) {
            errors.push(t("masterData:phoneNumber", "Le champ Téléphone portable est invalide"));
        }

        if (type != "BAILLEUR") {
            if (!contact.hasOwnProperty('bailleurs') || !contact?.bailleurs.length > 0) {
                errors.push(t("masterData:bailleurs", "La liste des droits est vide, veuillez sélectionner au moins un bailleur"));
            }
        }
        if (type == "BAILLEUR") {
            if (!contact.id && !contact.hasOwnProperty('bailleur') || !contact.id && !checkValidity(contact?.bailleur, { isNumeric: true })) {
                errors.push(t("masterData:bailleur", "Veuillez sélectionner un bailleur"));
            }

          if (accessEnqueteType != "full")
            if ((!contact?.roles?.some(role => role === "BailleurAdministrateur") && havingHierarchieBailleur) && (!contact?.hasOwnProperty('rightEnquete') || !contact?.rightEnquete.length > 0 || accessEnqueteType == null)) {
                    errors.push(t("masterData:level", "La liste des droits est vide"));
                }
        }

        return errors;
    }

    const chekedLegacyItem = (access_data,keys) => {
        let tableau = access_data;
        let keysTemp = keys

        const checked = keysTemp.filter(element1 => {
            return !tableau.some(element => element1.includes(element));
        });
        if (checked.length > 0) {
            let item = checked[0];
            notyf.error(`Vous ne pouvez pas créer un utilisateur avec le droit "${item}". Vous devez modifier cela.`);
        }

        return checked.length == 0
    }

    const getKeyForItem = (item, n, m) => {
        let key = '';
        if (n > 0) {
            let temp = hierarchicalForEnquete?.filter((ligne) => ligne.libelle == item.libelle)[0]
            const { [niveau[m - n]?.libelle]: curent, ...rest } = temp;
            let p = hierarchicalForEnquete?.filter((item) => item.libelle == curent)[0].code
            key = p + ":" + key;
            key = key + getKeyForItem(item, n - 1, m)
        } else
            key = item.code
        return key

    }

    // Fonction pour vérifier si une clé est contenue dans une autre clé
    function isContained(k, otherKeys) {
        return otherKeys.some(otherKey => otherKey !== k && otherKey.startsWith(k));
    }

    const remindByMail = () => {
        let creationUser = {
            userDto: contact,
            AdresseMail: entity?.adresseMail || entityData.adresseMail,
            RaisonSociale: entity?.raisonSociale || entityData.raisonSociale,
            URL: entity?.url || entityData.url,
            Logo: entity?.logo || entityData.logo,
            Telephone: entity?.telephone || entityData.telephone,
            Fax: entity?.fax || entityData.fax,
        }
        Axios.post(import.meta.env.VITE_PREFIX_SERVER_IDENTITY + 'CreateUsers/remindByMail', { ...creationUser }).then(response => {

            // navigate(-1);
            notyf.success("L'email a été envoyé avec succès")
        }).catch(response => {
            notyf.error(t("mandat:generatedErrorMessage", "Une erreur s'est produite"))
        })
    }

    const getBailleurs = () => {
        Axios.get(import.meta.env.VITE_PREFIX_SERVER_API + `Bailleurs`, {
            params: null,
            headers: {
                "X-CSRF": "1",
            },
        }).then(res => {
            let temp = bailleursTries(res.data)
            setBailleurs(temp)
            return temp
        })
    }

    const DeleteUser = (userUid) => {
        Axios.delete(import.meta.env.VITE_PREFIX_SERVER_IDENTITY + `CreateUsers/deleteUser/${userUid}`).then(response => {
            if (response) {
                notyf.success(t("default:userAdded", "L'utilisateur a été supprimé avec succès"));
                getUsersPage(currentPage, filtersQuery, sortQuery, reverse, pageSize);
                setConfirmDeleteUser(false)
                closeModal()
            }
        }).catch(response => {
            notyf.error(t("mandat:generatedErrorMessage", "Une erreur s'est produite"))
        })
    }

    useEffect(() => {
        getBailleurs()
    }, [])
   
    useEffect(() => {
        if (!uidBailleur) {
            if (!contact?.id) {
                setUser({})
            } else {

              if (contact?.claims.some((item) => item.claimType == "bailleur_id"))
              {
                    setTypeUser('BAILLEUR')
                    let id = contact?.claims?.filter((item) => item.claimType == "bailleur_id")[0].claimValue
                    setInputValue(bailleurs?.filter((item) => item.id == id)[0]?.id);
                    getBailleurById(id).then((res) => {
                        setAccessEnqueteType(contact?.claims?.some(item => item.claimType == "access_data_key" && item.claimValue == res.libelleCourt + ":") ? "full" : "partial")
                            let apiKeysEnquete = contact?.claims?.filter((item) => item.claimType == "access_data_key")?.map((item) => { return item.claimValue }).join("|")
                            let resultEnquete = apiKeysEnquete.split(/[|:]/);
                            let RightEnqueteArray = res.hierarchicalTemp?.filter((item, index) => resultEnquete.includes(item.code))

                        setAccessAttestationType(contact?.claims?.some(item => item.claimType == "access_data_assu_key" && item.claimValue == res.libelleCourt + ":") ? "full" : "partial")
                            let apiKeysAttestation = contact?.claims?.filter((item) => item.claimType == "access_data_assu_key")?.map((item) => { return item.claimValue }).join("|")
                            let resultAttestation = apiKeysAttestation.split(/[|:]/);
                            let RightAttestationArray = res.hierarchicalTemp?.filter((item, index) => resultAttestation.includes(item.code))

                            let Temp = {
                                ...contact,
                                rightEnquete: RightEnqueteArray,
                                rightAttestation: RightAttestationArray,
                                permissions: contact?.claims?.filter((item) => item.claimType == "permissions"),
                             /* key: apiKeysEnquete,*/
                                bailleur: id
                            }
                            setUser(Temp)
                    }).catch(error => {
                        console.error("Une erreur s'est produite lors de la récupération des données :", error);
                    });
               }else
                    {
                        setTypeUser('INTERNE')
                        let apiKeysEnquete = contact?.claims.filter((item) => item.claimType == "access_data_key")?.map((item) => { return item.claimValue }).join("|")
                        let resultEnquete = apiKeysEnquete.split(/[|:]/);
                        const bailleursEnqueteList = bailleurs.filter(element1 => {
                          return resultEnquete.some(element2 => element1.libelleCourt == element2);
                        });

                        let apiKeysAttestation = contact?.claims.filter((item) => item.claimType == "access_data_assu_key")?.map((item) => { return item.claimValue }).join("|")
                        let resultAttestation = apiKeysAttestation.split(/[|:]/);
                        const bailleursAttestationList = bailleurs.filter(element1 => {
                          return resultAttestation.some(element2 => element1.libelleCourt == element2);
                        });

                        let Temp = {
                            ...contact,
                            permissions: contact?.claims?.filter((item) => item.claimType == "permissions"),
                            bailleurs: bailleursEnqueteList,
                            bailleursAA: bailleursAttestationList
                        }
                        console.log(Temp)
                        setUser(Temp)
                    }
            }
        }
        if (uidBailleur) {

            setHavingHierarchieBailleur(hierarchicalTemp.length > 0)
            let resultEnquete = access_data_key?.join('|')?.split(/[|:]/);
            let levelEnqueteArrayTemp = hierarchicalTemp?.filter((item, index) => resultEnquete.includes(item.code))
            //on ajoutes la properiete isLegacy: true pour indique que c'est un droit herité de parent
            let levelEnqueteArray = levelEnqueteArrayTemp.map((item, index) => { return { ...item, isLegacy: true } })

            let dataKeysEnquete = userType == "ADMIN_YOUNOV" ? [""] : access_data_key;
            const keysEnquete = hierarchicalTemp.filter(h => {
                  return dataKeysEnquete.some(key => h.path.includes(key) && h.path > key);
            });
              //////////////////////////////////////////////////////////////////////////////////////
            let resultAttestation = access_data_assu_key?.join('|')?.split(/[|:]/);
            let levelAttestationArrayTemp = hierarchicalTemp?.filter((item, index) => resultAttestation.includes(item.code))
            let levelAttestationArray = levelAttestationArrayTemp.map((item, index) => { return { ...item, isLegacy: true } })

            let dataKeysAttestation = userType == "ADMIN_YOUNOV" ? [""] : access_data_assu_key;
            const keysAttestation = hierarchicalTemp.filter(h => {
              return dataKeysAttestation.some(key => h.path.includes(key) && h.path > key);
            });

            setHierarchicalForAttestation([...keysAttestation, ...levelAttestationArray])
            setHierarchicalForEnquete([...keysEnquete, ...levelEnqueteArray])


            setNiveau(niveauTemp)
            setBailleurCode(codeBailleur)
            if (!contact?.id) {
                let rolesDefault = userType == "BAILLEUR" ? ["Bailleur"] : [];
                let Temp = {
                    ...user,
                    rightEnquete: levelEnqueteArray,
                    rightAttestation: levelAttestationArray,
                    permissions: [],
                    bailleur: uidBailleur,
                    roles: rolesDefault
                }

                setUser(Temp)
            }
            else {
              setAccessEnqueteType(contact?.claims?.some(item => item.claimType == "access_data_key" && item.claimValue == codeBailleur + ":") ? "full" : "partial")
                let apiKeysEnquete = contact?.claims.filter((item) => item.claimType == "access_data_key")?.map((item) => { return item.claimValue }).join("|")
                let resultEnquete = apiKeysEnquete.split(/[|:]/);
                let levelArrayEnquete = hierarchicalTemp.filter((item, index) => resultEnquete.includes(item.code))

              setAccessAttestationType(contact?.claims?.some(item => item.claimType == "access_data_assu_key" && item.claimValue == codeBailleur + ":") ? "full" : "partial")
              let apiKeysAttestation = contact?.claims.filter((item) => item.claimType == "access_data_assu_key")?.map((item) => { return item.claimValue }).join("|")
              let resultAttestation = apiKeysAttestation.split(/[|:]/);
              let levelArrayAttestation = hierarchicalTemp.filter((item, index) => resultAttestation.includes(item.code))
              

              
                let Temp = {
                    ...contact,//contact
                    rightEnquete: levelArrayEnquete,
                    rightAttestation:levelArrayAttestation,
                    permissions: contact?.claims?.filter((item) => item.claimType == "permissions"),
                  /*key: apiKeysEnquete,*/
                    bailleur: uidBailleur
                }
                setUser(Temp)
            }
        }
    }, [hierarchicalTemp, contact, bailleurs, niveauTemp, uidBailleur])

    const handleInputChange = e => {
        const key = e.target.name;
        var value = e.target.value;
        if (key == "actif") {
            e.target.checked ? value = 1 : value = 0;
        }
        const newUser = { ...user, [key]: value };
        setUser(newUser);
    }

    const handleInputChangeName = (e) => {
        // TODO: l'identifiant n'est pas modifiable si l'utilisateur est déjà créé
        const key = e.target.name;
        var value = e.target.value;

        let displayName = "";
        let claimsTemp = user?.claims || [];
        let keyIndex = claimsTemp.findIndex(ent => ent.claimType === "urn:younov:displayname");
        if (keyIndex >= 0) {
            let displayNameArray = claimsTemp[keyIndex]?.claimValue.split(".")
            if (key == "prenom") {
                if (displayNameArray.length > 1) {
                    displayName = value + "." + displayNameArray[1]
                } else {
                    displayName = value + "."
                }
            }
            if (key == "nom") {
                if (displayNameArray.length >= 1) {
                    displayName = displayNameArray[0] + "." + value
                } else {
                    displayName = "." + value
                }
            }
            let p = { claimType: "urn:younov:displayname", claimValue: displayName }
            claimsTemp[keyIndex] = p
        }
        else {
            if (key == "prenom") {
                displayName = value + "."
            }
            if (key == "nom") {
                displayName = "." + value
            }
            let p = { claimType: "urn:younov:displayname", claimValue: displayName }
            claimsTemp.push(p);
        }

        /*
        if (displayName?.split(".")?.length > 1) {
            let identifiant = (displayName.split(".")[0].charAt(0).toUpperCase() + displayName.split(".")[1]).normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            const newUser = { ...user, userName: identifiant, claims: claimsTemp };
            setUser(newUser);
        } else {
            const newUser = { ...user, claims: claimsTemp };
            setUser(newUser);
        }
        */

        const newUser = { ...user, claims: claimsTemp };
        setUser(newUser);
    }

    const inputChangeTypeUser = e => {
        setTypeUser(e.target.value);
        setUser({ ...user, roles: [], bailleurs: [], bailleursAA:[], bailleur: null, rightEnquete: [], rightAttestation: [], permissions: [] });
    }

    const addEntityclickHandler = () => {
        let checked = true;
        let userData = null;
        if (typeUser === "BAILLEUR") {
            let checkErrors = checkUserFormValidity(user, "BAILLEUR");
            if (checkErrors && checkErrors.length > 0) {
                setErrors(checkErrors);
                checked = false;
            } else {
                setErrors([]);
                let userLevel = [...user?.rightEnquete];
                let userRightAttestation = [...user?.rightAttestation];
                let keyEnquete = userLevel?.map(item => { return bailleurCode + ":" + getKeyForItem(item, item.index, item.index); })//on peut utiliser le path 
                let keyAttestation = userRightAttestation?.map(item => { return bailleurCode + ":" + getKeyForItem(item, item.index, item.index); })//on peut utiliser le path 
                // Filtrer les clés en supprimant celles qui sont contenues dans d'autres clés ex LORY:ORG2 ET LORY:ORG2:AG2 on supprime LORY:ORG2
                const filteredKeys = keyEnquete.filter((k, index) => !isContained(k, keyEnquete.filter((_, i) => i !== index)));
                let ClaimsArray = (user.roles.some(role => role === "BailleurAdministrateur") || accessEnqueteType =="full" || !havingHierarchieBailleur) ?
                    [{ ClaimType: "access_data_key", claimValue: bailleurCode + ":" }]
                    :
                filteredKeys.map((item, index) => { return { claimType: "access_data_key", claimValue: item + ":" } })
              ////

              const filteredKeysAA = keyAttestation.filter((k, index) => !isContained(k, keyAttestation.filter((_, i) => i !== index)));
                let ClaimsArrayAA = (user.roles.some(role => role === "BailleurAdministrateur") || accessAttestationType == "full" || !havingHierarchieBailleur) ?
                [{ ClaimType: "access_data_assu_key", claimValue: bailleurCode + ":" }]
                :
                filteredKeysAA.map((item, index) => { return { claimType: "access_data_assu_key", claimValue: item + ":" } })
///
                let claimBailleur = { claimType: "bailleur_id", claimValue: uidBailleur || user?.bailleur }
                let claimTenant = { claimType: "tenant_id", claimValue: uidBailleur || user?.bailleur }

                ClaimsArray = ClaimsArray.concat(ClaimsArrayAA)
                ClaimsArray.push(claimBailleur);
                ClaimsArray.push(claimTenant);

                if (user?.claims?.filter(claim => claim?.claimType == "urn:younov:displayname")[0]) {
                    ClaimsArray.push(user?.claims?.filter(claim => claim?.claimType == "urn:younov:displayname")[0]);
                }

                userData = {
                    ...user,
                    claims: ClaimsArray.concat(user.permissions)
                };
                //car il se peut de supprimer un droit qui gener un autre droit qu'on peut pas attribuer ex:LORY:ORG2:AG2 si on supprime AG2 On aura LORY:ORG2 comme droit alors que c'est un droit sup et pas inf
              checked = user.roles.some(role => role === "BailleurAdministrateur") ? true : (chekedLegacyItem(access_data_key, filteredKeys.map((item, index) => item + ":")) && chekedLegacyItem(access_data_assu_key, filteredKeysAA.map((item, index) => item + ":")) );
            }
        } else {
            let checkErrors = checkUserFormValidity(user, "INTERN");
            if (checkErrors && checkErrors.length > 0) {
                setErrors(checkErrors);
                checked = false;
            } else {
              let ClaimsArray = user.bailleurs.map((item, index) => { return { claimType: "access_data_key", claimValue: item.libelleCourt + ":" } });
              let ClaimsArrayAA = user.bailleursAA.map((item, index) => { return { claimType: "access_data_assu_key", claimValue: item.libelleCourt + ":" } });
              ClaimsArray.push(user?.claims?.filter(claim => claim?.claimType == "urn:younov:displayname")[0]);
              ClaimsArray = ClaimsArray.concat(ClaimsArrayAA)
                setErrors([]);
                userData = {
                    ...user,
                    claims: ClaimsArray.concat(user.permissions),
                };
            }
        }
        // Si l'utilisateur est interne, pas besoin des autres propriétés (logo, URL, fax)
        let entityTemp = typeUser === "BAILLEUR" ? entityData:null
        if (checked) {
            let creationUser = {
                UserDto: userData,
                AdresseMail: entity?.adresseMail || entityTemp?.adresseMail,
                RaisonSociale: entity?.raisonSociale || entityTemp?.raisonSociale,
                URL: entity?.url || entityTemp?.url,
                Logo: entity?.logo || entityTemp?.logo,
                Telephone: entity?.telephone || entityTemp?.telephone,
                Fax: entity?.fax || entityTemp?.fax,
            }

            Axios.post(import.meta.env.VITE_PREFIX_SERVER_IDENTITY + 'CreateUsers/addUser', { ...creationUser }).then(response => {
                closeModal();
                getUsersPage(currentPage, filtersQuery, sortQuery, reverse, pageSize);
                notyf.success("L'utilisateur a été créé avec succès");
            }).catch(errs => {
                let errors = [];
                errs?.response?.data?.forEach((err, index) => {
                    if (err.code == "DuplicateUserName")
                        errors.push("L'identifiant existe déjà. Veuillez en choisir un autre");
                    else
                        errors.push(err.description);
                });
                setErrors(errors);
                notyf.error(t("mandat:generatedErrorMessage", "Une erreur s'est produite"));
            })
        }
    }

    const editEntityclickHandler = () => {
        let checked = true;
        let userData = null;
        if (typeUser === "BAILLEUR") {
            let checkErrors = checkUserFormValidity(user, "BAILLEUR");
            if (checkErrors && checkErrors.length > 0) {
                setErrors(checkErrors);
                checked = false;
            } else {

              setErrors([]);
              let userRightAttestation = [];
              if (user?.rightAttestation) {
                userRightAttestation = [...user?.rightAttestation];
              }

              let userLevel = [];
              if (user?.rightEnquete) {
                userLevel = [...user?.rightEnquete];
              }

              let keyAttestation = userRightAttestation?.map(item => { return bailleurCode + ":" + getKeyForItem(item, item.index, item.index); })//on peut utiliser le path

              const filteredKeysAA = keyAttestation.filter((k, index) => !isContained(k, keyAttestation.filter((_, i) => i !== index)));
              let ClaimsArrayAA = (user.roles.some(role => role === "BailleurAdministrateur") || accessAttestationType == "full" || !havingHierarchieBailleur) ?
                [{ ClaimType: "access_data_assu_key", claimValue: bailleurCode + ":" }]
                :
                filteredKeysAA.map((item, index) => { return { claimType: "access_data_assu_key", claimValue: item + ":" } })

              let keyEnquete = userLevel?.map(item => { return bailleurCode + ":" + getKeyForItem(item, item.index, item.index); })//on peut utiliser le path
                // Filtrer les clés en supprimant celles qui sont contenues dans d'autres clés ex LORY:ORG2 ET LORY:ORG2:AG2 on supprime LORY:ORG2
              const filteredKeys = keyEnquete.filter((k, index) => !isContained(k, keyEnquete.filter((_, i) => i !== index)));
              let ClaimsArray = (user.roles.some(role => role === "BailleurAdministrateur") || accessEnqueteType == "full" ||  !havingHierarchieBailleur) ?
                    [{ claimType: "access_data_key", claimValue: bailleurCode + ":" }]
                    :
                    filteredKeys.map((item, index) => { return { claimType: "access_data_key", claimValue: item + ":" } }
                    );

                let claimBailleur = { claimType: "bailleur_id", claimValue: uidBailleur || user?.bailleur };
                let claimTenant = { claimType: "tenant_id", claimValue: uidBailleur || user?.bailleur };

                if (user?.claims?.filter(claim => claim?.claimType == "urn:younov:displayname")[0]) {
                    ClaimsArray.push(user?.claims?.filter(claim => claim?.claimType == "urn:younov:displayname")[0]);
                }
              
                ClaimsArray = ClaimsArray.concat(ClaimsArrayAA);
                ClaimsArray.push(claimBailleur);
                ClaimsArray.push(claimTenant);
                userData = {
                    ...user,
                    claims: ClaimsArray.concat(user.permissions),
                };
              checked = user.roles.some(role => role === "BailleurAdministrateur") ? true : (chekedLegacyItem(access_data_key, filteredKeys.map((item, index) => item + ":")) && chekedLegacyItem(access_data_assu_key, filteredKeysAA.map((item, index) => item + ":")));
            }
        } else {
            let checkErrors = checkUserFormValidity(user, "INTERN");
            if (checkErrors && checkErrors.length > 0) {
                setErrors(checkErrors);
                checked = false;
            } else {
                setErrors([]);
              let ClaimsArray = user.bailleurs.map((item, index) => { return { claimType: "access_data_key", claimValue: item.libelleCourt + ":" } });
              let ClaimsArrayAA = user.bailleursAA.map((item, index) => { return { claimType: "access_data_assu_key", claimValue: item.libelleCourt + ":" } });

                if (user?.claims?.filter(claim => claim?.claimType == "urn:younov:displayname")[0]) {
                    ClaimsArray.push(user?.claims?.filter(claim => claim?.claimType == "urn:younov:displayname")[0]);
                }
              ClaimsArray = ClaimsArray.concat(ClaimsArrayAA);
              
                userData = {
                    ...user,
                    claims: ClaimsArray.concat(user.permissions),
                };
            }
        }

        if (checked)
            Axios.put(import.meta.env.VITE_PREFIX_SERVER_IDENTITY + `CreateUsers/updateUser/${user?.id}`, { ...userData }).then(response => {
                closeModal();
                getUsersPage(currentPage, filtersQuery, sortQuery, reverse, pageSize);
                notyf.success("L'utilisateur a été modifiée avec succès");
            }).catch(errs => {
                let errors = [];
                errs?.response?.data?.forEach((err, index) => {
                    if (err.code == "DuplicateUserName")
                        errors.push("L'identifiant existe déjà. Veuillez en choisir un autre");
                    else
                        errors.push(err.description);
                });
                setErrors(errors);
                notyf.error(t("mandat:generatedErrorMessage", "Une erreur s'est produite"));
            })
    }

    const saveClickHandler = () => {
        if (user?.id)
            editEntityclickHandler();
        else
            addEntityclickHandler();
    }

  /// liste des droits
  const deleteRightAttestation = (entity) => {
    let userTemp = { ...user };
    let userRightAttestation = [...user?.rightAttestation];
    let indexOfOrigineLevel = entity.index;
    let index = user?.rightAttestation?.findIndex(ent => ent.libelle === entity.libelle);
    if (indexOfOrigineLevel == niveau.length - 1) {
      if (index >= 0) {
        userRightAttestation.splice(index, 1);
      }
      setUser({
        ...userTemp,
        rightAttestation: userRightAttestation,
      });
    } else {
      let libelle = niveau[indexOfOrigineLevel].libelle;
      let value = entity.libelle;
      let nextElement = userRightAttestation.filter((iteme, id) => iteme.index == indexOfOrigineLevel + 1);
      let existe = nextElement.some((item) => item[libelle] == value);
      if (existe) {
        notyf.error("Vous ne pouvez pas supprimer cette ligne avant de supprimer les lignes attacheés à cette dernière");
      } else {
        if (index >= 0) {
          userRightAttestation.splice(index, 1);
        }
        setUser({
          ...userTemp,
          rightAttestation: userRightAttestation,
        });
      }
    }
  }

  const deleteRightEnquete = (entity) => {
        let userTemp = { ...user };
        let userRightEnquete = [...user?.rightEnquete];
        let indexOfOrigineLevel = entity.index;
         let index = user?.rightEnquete?.findIndex(ent => ent.libelle === entity.libelle);
        if (indexOfOrigineLevel == niveau.length - 1) {
            if (index >= 0) {
              userRightEnquete.splice(index, 1);
            }
            setUser({
                ...userTemp,
              rightEnquete: userRightEnquete,
            });
        } else {
            let libelle = niveau[indexOfOrigineLevel].libelle;
            let value = entity.libelle;
            let nextElement = userRightEnquete.filter((iteme, id) => iteme.index == indexOfOrigineLevel + 1);
            let existe = nextElement.some((item) => item[libelle] == value);
            if (existe) {
                notyf.error("Vous ne pouvez pas supprimer cette ligne avant de supprimer les lignes attacheés à cette dernière");
            } else {
                if (index >= 0) {
                  userRightEnquete.splice(index, 1);
                }
                setUser({
                    ...userTemp,
                  rightEnquete: userRightEnquete,
                });
            }
        }
    }

  const rightsEnqueteChangeHandler = (list, IndexLevel) => {
        let Temp = {
            ...user,
          rightEnquete: list,

        }
        setUser(Temp);
    }

  const rightsAttestationChangeHandler = (list, IndexLevel) => {
    let Temp = {
      ...user,
      rightAttestation: list,

    }
    setUser(Temp);
  }

  const getListItemByIndexLevel = (indexLevel, Type) => {
    const hierarchical =
        Type == "Enquete"
        ? hierarchicalForEnquete
        : hierarchicalForAttestation;
      const Rights =
          Type == "Enquete"
          ? user?.rightEnquete || []
          : user?.rightAttestation || [];

        if (indexLevel == 0) {
          return hierarchical?.filter((item, index) => item.index == indexLevel);
        } else {
          return hierarchical?.filter((item, index) =>
                  item.index === indexLevel &&
                  Rights?.filter((levelItem) => levelItem.index === indexLevel - 1).map((e) => { return e.libelle })
                    .includes(item[niveau[indexLevel - 1].libelle])
               );
        }
    }

  const returnRightsForMap = useCallback((indexLevel, Type) => {
    const Rights =
      Type == "Enquete"
        ? user?.rightEnquete || []
        : user?.rightAttestation || [];

        return (<div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {Rights.length > 0 ? Rights.filter((item) => item.index == indexLevel).map(entity => (
                    <EntFormItem color={entity.isLegacy ? "#cb0c9f" : "#2174B980"} key={entity.libelle} >
                        <span>{entity.libelle}</span>
                      < CloseIcon style={{ fontSize: "0.9rem", cursor: "pointer" }} onClick={() => Type == "Enquete" ? deleteRightEnquete(entity) : deleteRightAttestation(entity) } />
                    </EntFormItem>
                )) : null}
            </div>
        </div>
        )
    }
    , [user])

  const rightsDropDown = useCallback((indexLevel, Type) =>
    (<div style={{ display: "flex", flexDirection: "column" }}>
        <DropDownLevel
            indexLevel={indexLevel}
            niveau={niveau}
            entities={searchTreeHierarchie(getListItemByIndexLevel(indexLevel, Type), searchQueryHierarchie)}
            listItemsAlreadyExistes={Type == "Enquete" ? (user?.rightEnquete || []) : (user?.rightAttestation || []) }
            addEntitiesUser={Type == "Enquete" ? rightsEnqueteChangeHandler : rightsAttestationChangeHandler}
            setSearchQueryHierarchie={setSearchQueryHierarchie}
            searchQueryHierarchie={searchQueryHierarchie}
            title={"Ajouter une entité"}
        />
    </div>), [user, hierarchicalForEnquete, niveau, searchQueryHierarchie])

    ////////Liste des Bailleur
  const deleteBailleursEnquete = (entity) => {
        let userTemp = { ...user };
        let userBailleurs = [...user?.bailleurs];
        let index = user?.bailleurs?.findIndex(ent => ent.id === entity.id);
        if (index >= 0) {
            userBailleurs.splice(index, 1);
        }

        setUser({
            ...userTemp,
            bailleurs: userBailleurs,
        });
    }

  const deleteBailleursAttestation = (entity) => {
    let userTemp = { ...user };
    let userBailleurs = [...user?.bailleursAA];
    let index = user?.bailleursAA?.findIndex(ent => ent.id === entity.id);
    if (index >= 0) {
      userBailleurs.splice(index, 1);
    }

    setUser({
      ...userTemp,
      bailleursAA: userBailleurs,
    });
  }

    const bailleursEnqueteChangeTenantHandler = (list) => {
        let Temp = {
            ...user,
            bailleurs: list,
        }
        setUser(Temp);
  }

    const bailleursAttestationChangeTenantHandler = (list) => {
    let Temp = {
      ...user,
      bailleursAA: list,
    }
    setUser(Temp);
  }

    const returnBailleursForMap = useCallback((Type) => {
        const Bailleurs =
          Type == "Enquete"
            ? user?.bailleurs || []
            : user?.bailleursAA || [];

            return (<div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {Bailleurs?.length > 0 ? Bailleurs?.map(entity => (
                        <EntFormItem key={entity.id} >
                            <span>{entity.raisonSociale}</span>
                        <CloseIcon style={{ fontSize: "0.7rem", cursor: "pointer" }} onClick={() => Type == "Enquete" ? deleteBailleursEnquete(entity) : deleteBailleursAttestation(entity) } />
                        </EntFormItem>
                    )) : null}
                </div>
            </div>
            )
        }, [user])

    const bailleursDropDown = useCallback((Type) =>
    (<div style={{ display: "flex", flexDirection: "column" }}>
        <DropDown
            endpoint={"Bailleurs"}
            listItems={Type == "Enquete" ? (user?.bailleurs || []) : (user?.bailleursAA || [])}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            entities={searchTreeBailleur(bailleurs, searchQuery, (Type == "Enquete" ? user?.bailleurs : user?.bailleursAA))}
            addEntitiesUser={Type == "Enquete" ? bailleursEnqueteChangeTenantHandler : bailleursAttestationChangeTenantHandler}
            title="Ajouter une entité"
        />
    </div>
    ), [user, searchQuery, user?.bailleurs, user?.bailleursAA])

    ////////Liste des roles pour chaque type d utilisateur selon le type bailleur ou interne juste pour eviter de cree un user avec des roles qui lui corrseponds pas )
    const deleteRole = (role) => {
        let userTemp = { ...user };
        let userRoles = [...user?.roles];
        let index = user?.roles?.findIndex(ent => ent === role);
        if (index >= 0) {
            userRoles.splice(index, 1);
        }
        setUser({
            ...userTemp,
            roles: userRoles,
            permissions: [],
        })
        
    }

    const getRolesForUserType = () => {
        switch (typeUser) {
            case "BAILLEUR":
                let listTemp = listOfRoles?.filter((item, index) => item.type == 'Bailleurs');
                return userType == "ADMIN_YOUNOV" ? listTemp : listTemp.filter(item => item.libelle != "BailleurAdministrateur");
                break;
            case "INTERNE":
                let listTempForYounov = listOfRoles?.filter((item, index) => item.type == 'OperateurBackOffices');
                return listTempForYounov
                break;
            default:
                return [];
        }
    }

    const changeRoleHandler = (list) => {
        let Temp = {
            ...user,
            roles: list,
            permissions: []
        }

        setUser(Temp);
     
    }

    const returnRoleForMap = useMemo(() => {
        return (
            user?.roles?.length > 0 ? user?.roles?.map(role => (
                <EntFormItem color={"#82d616"} key={role} >
                    <span>{listOfRoles.filter((item) => item.libelle == role)[0].libelle}</span>
                    <CloseIcon style={{ fontSize: "0.7rem", cursor: "pointer" }} onClick={() => deleteRole(role)} />
                </EntFormItem>
            )) : null
        )
    }
    , [user])

    const rolesDropDown = useMemo(() =>
    (<>
        <DropDownRoles
            endpoint={"roles"}
            listRoles={getRolesForUserType()}
            IsMulti={typeUser == "BAILLEUR" ? false : true}
            listItems={user?.roles || []}
            addEntitiesUser={changeRoleHandler}
            title="Ajouter un role"
        />
        <EntFormList>
            {returnRoleForMap}
        </EntFormList>
    </>
    )
    , [user, typeUser])

    ////////Liste des permissions pour chaque type d utilisateur selon le type :bailleur ou interne  )
    const deletePermission = (permision) => {
        let userTemp = { ...user };
        let userPermissions = [...user?.permissions];
        if (permision.claimValue == "AjoutJustificatif") {
            let gestionDeriveIndex = user?.permissions?.findIndex(row => row.claimValue === "GestionDerive");
            if (gestionDeriveIndex >= 0) {
                userPermissions.splice(gestionDeriveIndex, 1);
            }
        }
        let index = user?.permissions?.findIndex(ent => ent.claimValue === permision.claimValue);
        if (index >= 0) {
            userPermissions.splice(index, 1);
        }
        setUser({
            ...userTemp,
            permissions: userPermissions,
        });
    }

    const changePermissionsHandler = (list) => {
        let Temp = {
            ...user,
            permissions: list
        }
        setUser(Temp);
    }

    const returnPermissionsForMap = useMemo(() => {
        return (
            user?.permissions?.length > 0 ? user?.permissions?.map(permission => (
                <EntFormItem color={"#82d616"} key={permission.claimType + "-" + permission.claimValue} >
                    <span>{permission.claimValue}</span>
                    <CloseIcon style={{ fontSize: "0.75rem", cursor: "pointer" }} onClick={() => deletePermission(permission)} />
                </EntFormItem>
            )) : null
        )
    }
        , [user])

    const permissionsDropDown = useMemo(() =>
    (<>
        <DropDownPermissions
            estGestionAdresse={uidBailleur ? entity?.estGestionAdresse : entityData?.estGestionAdresse}
            saisieInterne={uidBailleur ? entity?.saisieInterne : entityData?.saisieInterne}
            controleInterne={uidBailleur ? entity?.controleInterne : entityData?.controleInterne}
            roles={user?.roles || []}
            permissions={user?.permissions || []}
            updatePermissions={changePermissionsHandler}
            title="Ajouter un role"
        />
        <EntFormList>
            {returnPermissionsForMap}
        </EntFormList>
    </>
    )
        , [user?.permissions, user])

    //////// des que l'admin YOUNOV selection un des bailleur on fait un appel api pour avoir les info qu'on aura besoin
    const getBailleurById = async (id) => {
        const response = await Axios.get(import.meta.env.VITE_PREFIX_SERVER_API + `Bailleurs/` + id, {
            params: null,
            headers: {
                "X-CSRF": "1",
            },
        })
        let hierarchicalBailleurTemp = null;
      setUser({ ...user, bailleur: id, rightEnquete: [], permissions: [] });
        setEntityData(response?.data);

        // on sauvgarde le code de bailleur on aura besoin de cette donnée pour construir la cle 
        setBailleurCode(response?.data.libelleCourt);// res.LibelleCourt
        let hierarchieBailleur = response?.data?.metadata?.hierarchieBailleur;
        setHavingHierarchieBailleur(hierarchieBailleur?.children?.length > 0);
        const levelTemp = hierarchieBailleur?.orderOfLevel?.split('/').map((item, index) => { return { libelle: item } });
        let firstLevel = hierarchieBailleur?.orderOfLevel?.split('/').map((item, index) => { return { libelle: item } })[0]?.libelle;
        setNiveau(levelTemp ? levelTemp : []);
        if (firstLevel != null) {
            hierarchicalBailleurTemp = getHierarchieBailleur(levelTemp, hierarchieBailleur);
          setHierarchicalForEnquete(hierarchicalBailleurTemp);
          setHierarchicalForAttestation(hierarchicalBailleurTemp);
        }
        return {
            levelTemp,
            hierarchicalTemp: hierarchicalBailleurTemp,
            libelleCourt: response.data.libelleCourt
        }
    }

    const administratorsManagingForUser = useMemo(() => {
        return (
            <>
                <EntFormList>
                    {userAdminForUserData?.length > 0 ?
                        userAdminForUserData?.map(admin => (
                            <EntFormItem color={"#fab134"} key={role.id} >
                                <span style={{ display: "flex" }}>{admin?.claims?.filter(claim => claim?.claimType == "urn:younov:displayname")[0]?.claimValue ?? ""}
                                    <IconDiv>
                                        <FontAwesomeIcon icon={faCircleInfo} style={{ marginLeft: "5px", marginRight: "2px" }} />
                                        <EICol >
                                            <strong style={{ color: "#344767", fontSize: "0.75rem" }}>Informations de l'utilisateur {admin?.claims?.filter(claim => claim?.claimType == "urn:younov:displayname")[0]?.claimValue ?? ""} :</strong>
                                            <div style={{ display: "flex", flexDirection: "column" }} >
                                                <span style={{ color: "#344767", fontSize: "0.65rem" }}>Email : {admin.email} </span>
                                                {/*<span style={{ color: "#344767", fontSize: "0.65rem" }}>Role : {admin.roles.map((role) => listOfRoles.filter((item) => item.roleId == role.roleId)[0].libelle).join(",")} .</span>*/}
                                                <span style={{ color: "#344767", fontSize: "0.65rem" }}>Téléphone : {admin.phoneNumber} </span>
                                                {/*<span style={{ color: "#344767", fontSize: "0.65rem" }}>Statut : {admin.lockoutEnd != null ? "Désactivé" : "Activé"}</span>*/}
                                            </div>
                                        </EICol>
                                    </IconDiv>
                                </span>
                            </EntFormItem>
                        ))
                        : <span>Aucun administrateur n'est actuellement responsable de cet utilisateur</span>}
                </EntFormList>
            </>

        )
    }
    , [user])

    const getLibelleRoleById = (id) => {
        return listOfRoles?.filter((item) => item?.roleId == id)[0]?.libelle
    }

    let tSpinner = false ? (<>
        <SpinnerContainer style={{ display: "flex", flexDirection: "column" }}>
            <Spinner animation="border" variant="primary" />
            <p>chargement ...</p>
        </SpinnerContainer>
    </>
    ) : null;

    let jsxActions = null;

    jsxActions = user?.id && ability.can('update', 'User') ?
        (
            <>
                {user?.id && <PrimaryBtnOutlineAction
                    style={{ backgroundColor: theme.colors.primary }}
                    onClick={remindByMail}
                >
                    <span>Renvoyer les identifiants</span>
                </PrimaryBtnOutlineAction>
                }

                <PrimaryBtnOutlineAction
                    style={{ backgroundColor: theme.colors.success }}
                    bd={theme.colors.success}
                    onClick={saveClickHandler}
                >
                    <span>Valider</span>
                </PrimaryBtnOutlineAction>

                {/*
                <CancelBtnOutlineAction onClick={
                    () => setConfirmDeleteUser(true)
                }>
                    <span>Supprimer</span>
                </CancelBtnOutlineAction>
                */}
            </>
        ) :
        (
            <>
                {!user?.id && ability.can('add', 'User') &&
                    <PrimaryBtnOutlineAction
                        style={{ backgroundColor: theme.colors.success }}
                        bd={theme.colors.success}
                        onClick={saveClickHandler}
                    >
                        <span>Valider</span>
                    </PrimaryBtnOutlineAction>
                }
            </>
        )
    const changeTypeAccessZonneBailleur = (value,Type) => {
      if (Type=="Enquete")
        setAccessEnqueteType(value);

      if (Type == "Attestation")
        setAccessAttestationType(value); 

    }
    return (
        <EntContainer>
            <EntHeaderWrapper>
                <EntHeaderTitleDiv>
                    <EntHeaderTitle style={{ marginLeft: "10px" }} color={theme.colors.secondary}>
                        {user?.id ? (user?.claims?.filter(claim => claim?.claimType == "urn:younov:displayname")[0]?.claimValue?.split(".")[0] || "") + " " +
                            (user?.claims?.filter(claim => claim?.claimType == "urn:younov:displayname")[0]?.claimValue?.split(".")[1] || "") : "Nouvel utilisateur"}
                    </EntHeaderTitle>
                </EntHeaderTitleDiv>
                <EntHeaderActions>
                    {
                        jsxActions
                    }
                    <CancelBtnOutlineAction
                        color={theme.colors.danger}
                        border={theme.colors.danger}
                        onClick={() => closeModal()}
                    >
                        Annuler
                    </CancelBtnOutlineAction>
                </EntHeaderActions>
            </EntHeaderWrapper>
            <EntContent>
                {tSpinner}
                <>
                    {
                        errors && errors.length > 0 ? (
                            <div className="alert alert-danger mt-2" role="alert">
                                <ul>
                                    {
                                        errors.map(error => (<li key={error}>{error}</li>))
                                    }
                                </ul>
                            </div>
                        ) : null
                    }
                    <EntInfosContainer>
                        <EIFormContainer2>
                            <EIContainer style={{ minHeight: '190px' }}>
                                <EntHeader>
                                    <EntHeaderTitle>
                                        <span style={{ display: "flex" }}>Informations</span>
                                    </EntHeaderTitle>
                                </EntHeader>
                                <EIFormCol>
                                    <EIFormColInfo >
                                        {!uidBailleur &&
                                            <FormGroup>
                                                <FormLabel htmlFor="langue">Type Utilisateur</FormLabel>
                                                <FormSelect
                                                    id="langue"
                                                    name="langue"
                                                    value={uidBailleur ? "BAILLEUR" : typeUser || ""}
                                                    onChange={(e) => inputChangeTypeUser(e)}
                                                >
                                                    <option value="BAILLEUR"> Bailleur </option>
                                                    <option value="INTERNE"> Interne</option>
                                                </FormSelect>
                                            </FormGroup>
                                        }
                                        {(typeUser == "BAILLEUR" || uidBailleur) ?
                                            uidBailleur ?
                                                <FormGroup>
                                                    <FormLabel htmlFor="bailleur">Bailleur</FormLabel>
                                                    <FormInput
                                                        style={{ textAlign: "right" }}
                                                        id="bailleur"
                                                        type="text"
                                                        name="bailleur"
                                                        value={bailleurs?.filter(item => item?.id == uidBailleur)[0]?.raisonSociale || ""}
                                                    />
                                                </FormGroup>
                                                :
                                                <FormGroup>
                                                    <FormLabel htmlFor="bailleur">Bailleur</FormLabel>
                                                    <FormSelect
                                                        id="bailleur"
                                                        name="bailleur"
                                                        value={inputValue}
                                                        onChange={(event) => {
                                                            setInputValue(event.target.value); getBailleurById(event.target.value);
                                                        }}
                                                    >
                                                        <option key="in" value=""></option>
                                                        {
                                                            bailleurs && bailleurs?.map(item => (
                                                                <option key={item.id} value={item.id}>{item.raisonSociale}</option>
                                                            ))
                                                        }
                                                    </FormSelect>
                                                </FormGroup>
                                            : null
                                        }

                                        <FormGroup>
                                            <FormLabel htmlFor="nom">Nom<MandatoryMarker /></FormLabel>
                                            <FormInput
                                                style={{ textAlign: "right" }}
                                                id="nom"
                                                type="text"
                                                name="nom"
                                                placeholder="Nom"
                                                value={user?.claims?.filter(claim => claim?.claimType == "urn:younov:displayname")[0]?.claimValue?.split(".")[1] || ""}
                                                onChange={handleInputChangeName}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <FormLabel htmlFor="prenom">Prénom<MandatoryMarker /></FormLabel>
                                            <FormInput
                                                style={{ textAlign: "right" }}
                                                id="prenom"
                                                type="text"
                                                name="prenom"
                                                placeholder="Prénom"
                                                value={user?.claims?.filter(claim => claim?.claimType == "urn:younov:displayname")[0]?.claimValue?.split(".")[0] || ""}
                                                onChange={handleInputChangeName}
                                            />
                                        </FormGroup>

                                        <FormGroup >
                                            <FormLabel htmlFor="login">Email<MandatoryMarker /></FormLabel>
                                            <FormInput
                                                style={{ textAlign: "right" }}
                                                id="login"
                                                type="text"
                                                name="email"
                                                placeholder="prenom.nom@societe.fr"
                                                value={user?.email || ""}
                                                onChange={handleInputChange}
                                            />
                                        </FormGroup>
                                        <FormGroup >
                                            <FormLabel htmlFor="given_name">Identifiant<MandatoryMarker /></FormLabel>
                                            <FormInput
                                                style={{ textAlign: "right" }}
                                                id="given_name"
                                                type="text"
                                                name="userName"
                                                placeholder="Utilisez votre adresse email"
                                                value={user?.userName}
                                                readOnly={!isNewUser}
                                                onChange={!isNewUser ? undefined : handleInputChange}
                                            />
                                        </FormGroup>
                                        <FormGroup >
                                            <FormLabel htmlFor="PhoneNumber">Téléphone portable</FormLabel>
                                            <FormInput
                                                style={{ textAlign: "right" }}
                                                id="PhoneNumber"
                                                type="text"
                                                name="phoneNumber"
                                                placeholder="0610203040"
                                                value={user?.phoneNumber || ""}
                                                onChange={handleInputChange}
                                            />
                                        </FormGroup>
                                    </EIFormColInfo>
                                    <div style={{ width: "48%", display: "flex", flexDirection: "column", justifyContent: "space-between", marginBottom: "5px" }}>
                                        <FormGroup>
                                            <FormLabel htmlFor="roles">Statut activé</FormLabel>
                                            {
                                                user?.lockoutEnd == null ? (
                                                    <CTooltip title={t('tableBody:disable', "Désactiver")} className="tableActions__icon">
                                                        <ToggleOnIcon
                                                            style={{ marginLeft: '0.25rem', color: theme.colors.secondary, cursor: 'pointer' }}
                                                            fontSize="large"
                                                            onClick={() => setUser({ ...user, lockoutEnd: new Date(2050, 0, 1) })}
                                                        />
                                                    </CTooltip>
                                                ) :
                                                    <CTooltip title={t('tableBody:enable', "Activer")} className="tableActions__icon">
                                                        <ToggleOffIcon
                                                            style={{ marginLeft: '0.25rem', cursor: 'pointer', color: theme.colors.younovGray }}
                                                            fontSize="large"
                                                            onClick={() => setUser({ ...user, lockoutEnd: null })}
                                                        />
                                                    </CTooltip>
                                            }
                                        </FormGroup>
                                        <FormGroup>
                                            <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                                                <FormLabel htmlFor="name">Rôles<MandatoryMarker /></FormLabel>
                                                {rolesDropDown}
                                            </div>
                                        </FormGroup>
                                        <FormGroup>
                                            <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                                                <FormLabel htmlFor="name">Autorisations<MandatoryMarker /></FormLabel>
                                                {permissionsDropDown}
                                            </div>
                                        </FormGroup>
                                    </div>
                                </EIFormCol>
                            </EIContainer>
                        </EIFormContainer2>

                        <EIFormContainer2>
                            <EIContainer style={{ minHeight: "295px" }} border={theme.colors.orangeLight}>
                                <EntHeader>
                                    <EntHeaderTitle>
                                       <span style={{ display: "flex" }}>Droits d'accès aux enquêtes  </span>
                                    </EntHeaderTitle>
                                </EntHeader>
                                <EIFormCol2>
                                    {typeUser === "INTERNE" ?
                                        <>
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <FormLabel htmlFor="name" >Liste des bailleurs</FormLabel>
                                                 {bailleursDropDown("Enquete")}
                                            </div>
                                                {returnBailleursForMap("Enquete")}
                                        </>
                                        :

                                        (!user?.roles?.some(role => listOfRoles.filter((item) => item.libelle == role)[0].libelle == "BailleurAdministrateur") && havingHierarchieBailleur) ?
                                            <>
                                                <OptionContainer>
                                                    {/*<OptionDiv onClick={() => changeTypeAccessZonneBailleur("full")}>*/}
                                                    {/*    {accessType === "full" ? (*/}
                                                    {/*        <ToggleOnIcon*/}
                                                    {/*            style={{ marginLeft: '0.25rem', color: theme.colors.secondary, cursor: 'pointer' }}*/}
                                                    {/*            fontSize="large"*/}

                                                    {/*        />*/}
                                                    {/*    ) : (*/}
                                                    {/*        <ToggleOffIcon*/}
                                                    {/*            style={{ marginLeft: '0.25rem', cursor: 'pointer', color: theme.colors.younovGray }}*/}
                                                    {/*            fontSize="large"*/}

                                                    {/*        />*/}
                                                    {/*    )}*/}
                                                    {/*    <span>Accès complet</span>*/}
                                                    {/*</OptionDiv>*/}

                                                    <OptionDiv>
                                                        {accessEnqueteType === "partial" ? (
                                                            <ToggleOnIcon
                                                                onClick={(e) => changeTypeAccessZonneBailleur("full","Enquete")}
                                                                style={{ marginLeft: '0.25rem', color: theme.colors.secondary, cursor: 'pointer' }}
                                                                fontSize="large"

                                                            />
                                                        ) : (
                                                                <ToggleOffIcon
                                                                onClick={() => changeTypeAccessZonneBailleur('partial',"Enquete")}
                                                                style={{ marginLeft: '0.25rem', cursor: 'pointer', color: theme.colors.younovGray }}
                                                                fontSize="large"

                                                            />
                                                        )}

                                                        <span>Accès personnalisé</span>
                                                    </OptionDiv>
                                                </OptionContainer>
                                                 {accessEnqueteType === "partial" && (
                                                    niveau?.map((item, index) => (
                                                        <div key={index + 110} style={{
                                                            display: "flex",
                                                            padding: "4px",
                                                            flexWrap: "wrap",
                                                            borderBottom: "1px solid #dcecf7"
                                                        }}>

                                                            <div key={index + 11} style={{ display: "flex" }}>
                                                                <FormLabel htmlFor="name" >Liste des {niveau[index].libelle}</FormLabel>
                                                            {rightsDropDown(index, "Enquete")}
                                                            </div>
                                                            {returnRightsForMap(index ,"Enquete")}
                                                        </div>

                                                    )))}
                                                 {accessEnqueteType === "full" && (
                                                    <span>Cet utilisateur aura accès à toutes les zones du bailleur</span>
                                                )}
                                            </>
                                            :
                                            user.bailleur && <span>Cet utilisateur aura accès à toutes les zones du bailleur</span>
                                    }
                                </EIFormCol2>
                            </EIContainer>
                         </EIFormContainer2>

                        <EIFormContainer2>
                          <EIContainer style={{ minHeight: "295px" }} border={theme.colors.orangeLight}>
                            <EntHeader>
                              <EntHeaderTitle>
                         <span style={{ display: "flex" }}>Droits d’accès aux attestations d’assurance   </span>
                              </EntHeaderTitle>
                            </EntHeader>
                            <EIFormCol2>
                              {typeUser === "INTERNE" ?
                                <>
                                  <div style={{ display: "flex", alignItems: "center" }}>
                                    <FormLabel htmlFor="name" >Liste des bailleurs</FormLabel>
                                     {bailleursDropDown("Attestation")}
                                  </div>
                                     {returnBailleursForMap("Attestation")}
                                </>
                                :

                                (!user?.roles?.some(role => listOfRoles.filter((item) => item.libelle == role)[0].libelle == "BailleurAdministrateur") && havingHierarchieBailleur) ?
                                  <>
                                    <OptionContainer>
                         

                                      <OptionDiv>
                                         {accessAttestationType === "partial" ? (
                                          <ToggleOnIcon
                                            onClick={(e) => changeTypeAccessZonneBailleur("full","Attestation")}
                                            style={{ marginLeft: '0.25rem', color: theme.colors.secondary, cursor: 'pointer' }}
                                            fontSize="large"

                                          />
                                        ) : (
                                          <ToggleOffIcon
                                            onClick={() => changeTypeAccessZonneBailleur('partial',"Attestation")}
                                            style={{ marginLeft: '0.25rem', cursor: 'pointer', color: theme.colors.younovGray }}
                                            fontSize="large"

                                          />
                                        )}

                                        <span>Accès personnalisé</span>
                                      </OptionDiv>
                                    </OptionContainer>
                                      {accessAttestationType === "partial" && (
                                      niveau?.map((item, index) => (
                                        <div key={index + 110} style={{
                                          display: "flex",
                                          padding: "4px",
                                          flexWrap: "wrap",
                                          borderBottom: "1px solid #dcecf7"
                                        }}>

                                          <div key={index + 11} style={{ display: "flex" }}>
                                            <FormLabel htmlFor="name" >Liste des {niveau[index].libelle}</FormLabel>
                                            {rightsDropDown(index, "Attestation")}
                                          </div>
                                          {returnRightsForMap(index, "Attestation")}
                                        </div>

                                      )))}
                                      {accessAttestationType === "full" && (
                                      <span>Cet utilisateur aura accès à toutes les zones du bailleur</span>
                                    )}
                                  </>
                                  :
                             user.bailleur && <span>Cet utilisateur aura accès à toutes les zones du bailleur</span>
                              }
                            </EIFormCol2>
                          </EIContainer>
                        </EIFormContainer2>

                        {user?.id && ability.can('readAdminsGerant', 'User') &&
                            <EIFormContainer2>
                                <EIContainer border={theme.colors.danger} >
                                    <EntHeader>
                                        <EntHeaderTitle>
                                            <span style={{ display: "flex" }}>Liste des administrateurs gérant cet utilisateur</span>
                                        </EntHeaderTitle>
                                    </EntHeader>

                                    {administratorsManagingForUser}
                                </EIContainer>
                            </EIFormContainer2>
                        }
                    </EntInfosContainer>
                </>

                <ConfirmationModal
                    show={confirmDeleteUser}
                    modalClosed={() => setConfirmDeleteUser(false)}
                    confirm={() => DeleteUser(contact?.id)}
                    cancel={() => setConfirmDeleteUser(false)}
                    title={"Confirmation de désactivation"}
                    message={`Êtes-vous sûr de vouloir supprimer cet utilisateur (${contact?.email}) ?`}
                />
            </EntContent>
        </EntContainer>
    )
}

const mapStateToProps = (state) => ({
    userType: state.auth.userType,
    login: state.auth.login,
    userRoles: state.auth.userRoles,
  access_data_key: state.auth.access_data_key,
  access_data_assu_key: state.auth.access_data_assu_key,
    currentPage: state.users.currentPage,
    pageSize: state.users.pageSize,
    filtersQuery: state.users.filtersQuery,
    sortQuery: state.users.sortQuery,
    reverse: state.users.reverse,
    connectedUserId: state.auth.connectedUserId
})
const mapDispatchToProps = dispatch => ({
    getUsersPage: (page, filters, sort, reverse, pageSize) => dispatch(actions.usersGetPage(page, filters, sort, reverse, pageSize)),
})
export default connect(mapStateToProps, mapDispatchToProps)(UserEntity)
